import {
  calculateMonthlyPrice,
  removeTrailingZeros,
} from '@forest/paywall-core'
import { useStore } from '@nanostores/solid'
import { createResource } from 'solid-js'
import { productsReady } from '~/lib/message'
import { platform } from '~/lib/params'
import { m } from '~/paraglide/messages'
import { $chinaAndroidTrialEligibility, $isTrialEligible } from '~/store'

type FooterType = 'cna-trial' | 'cna' | 'trial' | 'subscribe'

export function FooterDescription() {
  const chinaAndroidTrialEligibility = useStore($chinaAndroidTrialEligibility)
  const isTrialEligible = useStore($isTrialEligible)
  const [products] = createResource(() => productsReady.promise)

  const footerType = (): FooterType => {
    if (platform === 'china_android') {
      return chinaAndroidTrialEligibility() === 'available'
        ? 'cna-trial'
        : 'cna'
    }
    return isTrialEligible() ? 'trial' : 'subscribe'
  }

  const footerText = () => {
    const type = footerType()
    const p = products()

    if (type === 'cna-trial') return m.onboarding_paywall_footer_trial_cna()
    if (type === 'cna') return m.onboarding_paywall_footer_cna()

    if (!p) return ''

    const earlyBird = p.annualEarlyBird

    if (type === 'trial') {
      const monthlyPrice = calculateMonthlyPrice({
        price_localized: earlyBird.price_localized,
        price_value: earlyBird.price_value,
      })
      return m.new_user_paywall_footer_free_ver({
        annual_plan_monthly_price: monthlyPrice,
        annual_plan_price: removeTrailingZeros(earlyBird.price_localized),
      })
    }

    const price = calculateMonthlyPrice({
      price_localized: earlyBird.price_localized,
      price_value: earlyBird.price_value,
    })
    return m.new_user_yearly_subscription_footer({
      yearly_price_month: price,
    })
  }

  return (
    <div class="px-6 text-center">
      <p class="text-xs text-white">{footerText()}</p>
    </div>
  )
}
